import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Projects } from '../../constants/ci-information.constant';
import { RouterModule } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-project-card-list',
  standalone: true,
  templateUrl: './project-card-list.component.html',
  imports: [RouterModule, NgFor, InputTextModule, NgIf],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProjectCardListComponent implements OnInit, AfterViewInit {

  public projects: any[] = Projects.filter(project => project.available);

  constructor(private _cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.scrollToTop();
  }

  ngOnInit(): void {
  }

  public filterNames(event: any) {
    const input = event.target as HTMLInputElement;

    if (input.value !== '') {
      this.projects = [];
      this.projects = Projects.filter((project: any) => 
        project?.name.toLowerCase().includes(input.value.toLowerCase())
      );
    } else {
      this.projects = [];
      this.projects = Projects;
    }
    this._cdr.detectChanges();
  }

  public scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public getBackgroundLink(link: string): string {
    return `url(${link})`;
  }
}
